<template>
    <van-popup v-model:show="localShow" position="bottom" round z-index="9" class="bg-#01031B color-#fff">
        <div class="w-full h-60px px-20px flex items-center justify-center">
            <div class="text-center text-16px font-500 text-16px font-900">
                {{ t('scene.changeScene') }}
            </div>
        </div>
        <div class="p-20px pt-10px px-0 relative">
            <div class="scene-list-container w-full h-full rounded-10px max-h-300px px-20px" ref="sceneListRef"
                @scroll="handleScroll">
                <div v-for="(item, index) in sceneList" :key="item.id" class="on-active-scene content-color relative p-4px rounded-10px mb-10px"
                    :class="{ 'active-scene': item.isSet }">
                    <div class="text-15px font-800 text-#fff pl-5px pb-10px">
                        {{ t('scene.sceneIndex', { num: index + 1 }) }}
                    </div>
                    <div class="w-full w-100% box-item-container message-content-html bg-color " v-html="renderMarkdown(item.firstMes)"
                        @click="handleSelectScene(item, index)">
                    </div>
                    <img src="@/assets/images/home/gouxuan.svg" alt="" class="absolute top--1px right--1px w-16px h-16px"
                        v-if="item.isSet">
                </div>
            </div>
            <!-- 📱 自定义滚动指示器（移动端可见） -->
            <div v-if="showScrollbar" class="custom-scrollbar">
                <div class="scrollbar-thumb" :style="scrollbarStyle"></div>
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMarkdown } from '@/composables/useMarkdown'
import { theme } from "@/styles/theme";

const { t } = useI18n()

interface Scene {
    id: string | number
    firstMes: string
    isSet: boolean
    [key: string]: any
}

interface Props {
    show: boolean
    sceneList: Scene[]
}

const props = withDefaults(defineProps<Props>(), {
    show: false,
    sceneList: () => []
})

const emit = defineEmits<{
    (e: 'update:show', value: boolean): void
    (e: 'select', scene: Scene, index: number): void
}>()

const { renderMarkdown } = useMarkdown()

const localShow = computed({
    get: () => props.show,
    set: (value: boolean) => emit('update:show', value)
})

const handleSelectScene = (item: Scene, index: number) => {
    emit('select', item, index)
}

// 📱 自定义滚动指示器
const sceneListRef = ref<HTMLElement>()
const showScrollbar = ref(false)
const scrollbarStyle = ref({
    height: '0px',
    top: '0px'
})

const handleScroll = () => {
    const el = sceneListRef.value
    if (!el) return

    const { scrollTop, scrollHeight, clientHeight } = el

    // 判断是否需要显示滚动条
    showScrollbar.value = scrollHeight > clientHeight

    if (showScrollbar.value) {
        // 计算滚动条高度和位置
        const scrollbarHeight = (clientHeight / scrollHeight) * clientHeight
        const scrollbarTop = (scrollTop / scrollHeight) * clientHeight

        scrollbarStyle.value = {
            height: `${scrollbarHeight}px`,
            top: `${scrollbarTop}px`
        }
    }
}

onMounted(() => {
    // 初始化时检查是否需要滚动条
    setTimeout(() => {
        handleScroll()
    }, 100)
})

onUnmounted(() => {
    showScrollbar.value = false
})
</script>

<style scoped lang="scss">
// 场景列表容器滚动条样式
.scene-list-container {
    h3 {
        font-size: 14px !important;
    }

    -webkit-overflow-scrolling: touch;
    overflow-y: scroll !important;

    // Firefox 蓝色滚动条
    // scrollbar-width: thin !important;
    // scrollbar-color: #5a68ff transparent !important;

    // // 自定义蓝色滚动条 - 移动端和桌面端都生效
    // &::-webkit-scrollbar {
    //     display: block !important;
    //     width: 6px !important;
    //     -webkit-appearance: none !important; // 禁用原生样式
    // }

    // &::-webkit-scrollbar-track {
    //     background: transparent !important;
    //     border-radius: 4px;
    //     -webkit-box-shadow: none !important;
    // }

    // &::-webkit-scrollbar-thumb {
    //     background: rgba(90, 104, 255, 0.6) !important; // 蓝色
    //     border-radius: 4px;
    //     -webkit-border-radius: 4px !important;
    //     border: none !important;

    //     &:hover {
    //         background: rgba(90, 104, 255, 0.8) !important;
    //     }

    //     &:active {
    //         background: rgba(90, 104, 255, 1) !important;
    //     }
    // }

    // 📱 移动端强制显示滚动条的额外处理
    // &::-webkit-scrollbar-button {
    //     display: none !important;
    // }
}

// 📱 自定义滚动指示器样式（移动端可见）
.custom-scrollbar {
    position: absolute;
    right: 2px;
    top: 10px;
    bottom: 10px;
    width: 4px;
    // background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
    pointer-events: none;
    z-index: 10;
}

.scrollbar-thumb {
    position: absolute;
    width: 100%;
    // background: rgba(90, 104, 255, 0.8);
    background: rgba(255, 255, 255, 0.3);

    border-radius: 2px;
    transition: background 0.2s;
}

.bg-color {
    background: rgba(255, 255, 255, 0.15);
}

.box-item-container {
    border-radius: 5px;
    padding: 10px 6px;
    line-height: 1.4;
    max-height: calc(1.4em * 4);
    overflow-y: auto;
    word-wrap: break-word;
    border: 1px solid transparent;

    h3 {
        font-size: 14px !important;
    }
}


.on-active-scene{
    border: 1px solid rgba(255, 255, 255, 0.15);
}
.active-scene {
    border: 1px solid #7284F7;
}
.content-color {
    em {
        color: v-bind('theme.colors.textPrimarySix') !important;
    }
}
.message-content-html {
    font-size: 16px;
    /* 全局开启换行与断行，处理没有被 <p> 包裹的文本节点 */
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;

    :deep(p) {
        color: v-bind('theme.colors.textPrimary');
        white-space: pre-wrap;
        /* 保留换行 */
        word-break: break-word;
        /* 长单词断行 */
        overflow-wrap: anywhere;
        /* 连续字符换行 */
        margin: 0;
        /* 与 <br/> 搭配，避免额外间距 */

        font-style: italic;

    }

    img {
        max-width: 100%;
        height: auto;
        display: block;
        border-radius: 6px;
    }



    :deep(em) {
        color: v-bind('theme.colors.textPrimarySix') !important;
    }

    // 🔧 对话和旁白样式
    :deep(.dialogue) {
        // 引号内的对话 - 白色
        color: #fff;
        font-style: normal;

        em {
            color: #fff !important;
            font-style: normal;
        }
    }

    :deep(.narration) {
        // 引号外的旁白 - 灰色
        color: #999;
        opacity: 0.8;
        font-style: italic;
    }

    // 链接样式
    a {
        color: v-bind('theme.colors.primary');
        text-decoration: underline;

        &:hover {
            color: v-bind('theme.colors.primaryHover');
        }

        &:active {
            color: v-bind('theme.colors.primaryActive');
        }
    }

    // 标题样式
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: #fff;
        margin: 8px 0;
        line-height: 1.3;
    }

    // 强调/加粗

    // 行内代码
    code:not(.hljs) {
        background: rgba(255, 255, 255, 0.08) !important;
        color: #fff;
        padding: 2px 6px;
        border-radius: 6px;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    }

    // 代码块（已由 highlight.js 样式表控制，这里微调暗色背景适配）
    pre.hljs {
        background: transparent !important;
        border-radius: 10px;
        padding: 12px;
        overflow-x: auto;
        white-space: pre-wrap; // 允许换行并保留缩进
        word-break: break-word; // 遇到长单词或长链接也换行
        overflow-wrap: anywhere; // 进一步保证超长连续字符可换行
    }

    // 使内部 code 继承换行策略
    pre.hljs code {
        white-space: inherit;
        word-break: inherit;
        overflow-wrap: inherit;
        max-width: 100%;
        display: block;
    }

    // 引用
    blockquote {
        border-left: 3px solid v-bind('theme.colors.primary');
        margin: 8px 0;
        padding: 6px 10px;
        background: rgba(255, 255, 255, 0.04);
        color: v-bind('theme.colors.textSecondary');
        border-radius: 6px;
    }

    // 列表
    ul li,
    ol li {
        color: v-bind('theme.colors.textPrimary');
        margin: 4px 0;
    }
}
</style>
